module.exports = __webpack_public_path__ + "static/media/crob.56d0a961.svg";